import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/profile/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    pageTitle: 'Agreement',
    tabKey: 'agreement/profile',
  },
  pendingComponent: Loading,
});
